"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPatternId = void 0;
const getPatternId = (state = {}) => state.patternId || '';
exports.getPatternId = getPatternId;
//# sourceMappingURL=patternSelectors.js.map